// import Webinar from './alpine/webinar'

document.addEventListener('alpine:init', _ => {
    // window.Alpine.data('Webinar', Webinar)
})
